/**
 * Prefetch data client side.
 */

import { useEffect } from 'react';

import UserSavedSearchService from '../../services/user-saved-search.service';
import { saveUserSearches } from '../../store/actions/user-saved-searches.actions';
import { useAppSelector } from '../../store/hooks';

const userSavedSearchService = new UserSavedSearchService();

export const PrefetchClientSide = () => {
  const user = useAppSelector(({ userData }) => userData.user);

  const prefetchUserSavedSearches = async () => {
    try {
      // Fetch.
      const userSavedSearches = await userSavedSearchService.getUserSavedSearches();

      // Save to store.
      saveUserSearches(userSavedSearches);
    } catch (err) {
      console.error('Failed to fetch user saved searches', err.message);
    }
  };

  useEffect(() => {
    if (user.isLoggedIn) {
      Promise.all([
        // List of data to prefetch
        prefetchUserSavedSearches(),
      ]);
    }
  }, [user]);

  return null;
};
